<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">Most Consumed Product Type</h4>
    <div class="card-toggle">
      <button 
        class="toggle-btn" 
        [class.active]="mostConsumedProductTypeCategory === 'body_part'"
        (click)="onToggle('body_part')">
        Body Part
      </button>
      <button 
        class="toggle-btn" 
        [class.active]="mostConsumedProductTypeCategory === 'implant'"
        (click)="onToggle('implant')">
        Implant
      </button>
    </div>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingMostConsumedProductType" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading most consumed product type...</span>
    </div>
    <div *ngIf="!isLoadingMostConsumedProductType && (!mostConsumedProductTypeData?.product_types || mostConsumedProductTypeData.product_types.length === 0)" class="no-data-message empty-state-message">
      <i class="fa fa-tags empty-icon" aria-hidden="true"></i>
      <span>No product type data available for the selected date range.</span>
    </div>
    <canvas #chart4 class="chart-canvas" [style.display]="isLoadingMostConsumedProductType || !mostConsumedProductTypeData?.product_types || mostConsumedProductTypeData.product_types.length === 0 ? 'none' : 'block'"></canvas>
  </div>
</div>
